import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth travels in an httpOnly cookie set by the backend; only the selected site id lives client-side.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const site = localStorage.getItem("brigata_site");
  if (site) config.headers["X-Site-Id"] = site;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const path = window.location.pathname;
    const isPublic = path.startsWith("/login") || path.startsWith("/public") || path.startsWith("/portale") || path.startsWith("/presentazione");
    if (error.response?.status === 401 && !isPublic) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  if (!e) return "Si è verificato un errore";
  if (!e.response) return "Connessione assente: riprova quando torni online";
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e.message || "Si è verificato un errore";
}

export function fileUrl(id) {
  return `${API}/files/${id}`;
}
